module.exports = __webpack_public_path__ + "img/malaga.9727b058.jpg";